import summaryApi from "../common/Api";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

const addToCart = async (e, id) => {
  e.stopPropagation();
  e.preventDefault();

  try {
    const token = Cookies.get("tokenApi");
    if (!token) {
      // console.error('Token not found!');
      toast.error("Please login first!", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
      return;
    }

    const response = await axios.post(
      summaryApi.addToCart.url,
      {
        productId: id,
        quantity: 1,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );

    //   console.log('Product added to cart:', response.data);

    toast.success("Product added to cart successfully!", {
      position: "bottom-center",
      className: "custom-toast",
      autoClose: 2000,
      draggable: true,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggablePercent: 60,

    });
    return response.data;
  } catch (error) {
    //   console.error('Error adding product to cart:', error?.response?.data.message);
    toast.warning(error?.response?.data.message, {
      position: "bottom-center",
      className: "custom-toast",
      autoClose: 2000,
      draggable: true,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggablePercent: 60,
    });
  }
};

export default addToCart;
